import styled from 'styled-components';

export const CenterDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const CoupleFriendlyTagContainer = styled.div(
  props => `
  padding: 0 0 0 ${props.theme.spacing.base};
`,
);
